import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [hovered, setHovered] = useState<string | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="w-full max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-4">
            <i className="ri-apps-line" />
            视频分类
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            探索热门视频分类
          </h2>
          <p className="text-foreground-500 text-base md:text-lg max-w-xl">
            六大精选分类，覆盖电影、剧集、综艺、动漫、纪录片和音乐，满足您的所有观影需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative aspect-[4/5] rounded-2xl overflow-hidden cursor-pointer"
              onMouseEnter={() => setHovered(cat.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent" />

              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <h3 className="text-white text-xl md:text-2xl font-bold mb-1.5">
                  {cat.name}
                </h3>
                <p className="text-foreground-400 text-sm mb-3 line-clamp-2">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-400 text-xs">
                    {cat.videoCount.toLocaleString()} 部视频
                  </span>
                  <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>

              {hovered === cat.id && (
                <div className="absolute inset-0 bg-primary-500/10 transition-colors duration-300" />
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}